export const REGION_HREF = process.env.appmode === 'LTS'
  ? {
    EU: 'https://ieu.ltsplatinumpartner.com',
    SA: 'https://isa.ltsplatinumpartner.com',
    SGP: 'https://isgp.ltsplatinumpartner.com',
    US: 'https://ius.ltsplatinumpartner.com',
    IN: 'https://iind.ltsplatinumpartner.com',
    MAIN: 'https://www.ltsplatinumpartner.com'
  }
  : {
    EU: 'https://ieu.hik-partner.com',
    SA: 'https://isa.hik-partner.com',
    SGP: 'https://isgp.hik-partner.com',
    US: 'https://ius.hik-partner.com',
    RU: 'https://hik-partnerru.com',
    WWW_RU: 'https://www.hik-partnerru.com',
    MAIN: 'https://hik-partner.com',
    WWW_MAIN: 'https://www.hik-partner.com',
    GLOBAL: 'https://global.hik-partner.com',
    IN: 'https://iind.hik-partner.com'
  };

export const REGION_EU = [
  26, 27, 28, 29, 30, 0, 45, 1, 47, 52, 53, 56, 57, 59, 61, 62, 64, 65, 68, 69, 70, 73, 2, 75, 3, 4, 76, 80, 82, 83, 84,
  85, 86, 5, 6, 91, 92, 7, 94, 8, 99, 100, 9, 105, 109, 10, 115, 118, 122, 124, 125, 126, 127, 128, 129, 131, 132, 135,
  137, 138, 141, 142, 145, 146, 148, 150, 151, 152, 11, 158, 159, 12, 13, 14, 15, 173, 181, 182, 184, 16, 185, 186, 17,
  18, 189, 190, 19, 193, 20, 21, 195, 199, 202, 206, 207, 22, 213, 219, 220, 224, 225, 226, 227, 228, 289, 297, 308,
  309
];
export const REGION_SA = [34, 50, 54, 66, 67, 79, 87, 89, 101, 167, 168, 192, 210, 214];
export const REGION_SGP = [
  25, 35, 37, 38, 40, 42, 43, 49, 55, 60, 93, 104, 107, 108, 110, 112, 113, 114, 117, 119, 120, 121, 123, 130, 133, 134,
  136, 147, 58, 154, 161, 163, 164, 169, 171, 187, 191, 196, 194, 197, 198, 203, 204, 208, 211, 215, 218, 296, 183
];
export const REGION_US = [
  31, 32, 33, 36, 39, 41, 44, 46, 48, 51, 24, 63, 71, 72, 74, 77, 78, 81, 88, 90, 95, 96, 97, 98, 102, 103, 111, 116,
  139, 140, 143, 144, 149, 153, 155, 156, 157, 160, 162, 165, 166, 170, 174, 175, 176, 177, 178, 179, 180, 188, 200,
  201, 205, 23, 212, 216, 217, 221, 222, 223, 290, 291, 292, 293, 294, 295
];
export const REGION_RU = [172];
export const REGION_IN = [106];
